import { Loader } from "google-maps";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

var markers = [];
var markerCluster;

var $inputCountryName   = 'filter-countries';
var $inputRegionName    = 'filter-regions';
var $inputMetierName    = 'filter-metiers';

var $regionTabId    = '#regions-tab';
var $regionWrapId   = '#regions-wrap';
var $RegionISOCode  = 'FR';
var infowindow;

if(can_init_map == true) {
    // legacy ACF page fields map
    if (!has_cpt_implantation && typeof (locations) != 'undefined') {
        var loader = new Loader(maps_api_key, {
            version: "weekly",
            libraries: ["places"]
        });
        loader.load().then(function (google) {
            // console.log('Google Map API loaded');
            const map = new google.maps.Map(document.getElementById('map'), {
                center: { lat: 0, lng: 0 },
                zoom: 2,
                styles: require('./map.json'),
                disableDefaultUI: true,
                zoomControl: true,
            });
            infowindow = new google.maps.InfoWindow({
                pixelOffset: new google.maps.Size(-1, 45)
            });

            var positions = [];
            locations.map((position, i) => {
                if (typeof position.adresse.lat === "number" && typeof position.adresse.lng === "number") {
                    positions.push(position);
                }
            });

            // Add some markers to the map.
            const markers = positions.map((position, i) => {
                if (typeof position.adresse.lat === "number" && typeof position.adresse.lng === "number") {
                    const marker = new google.maps.Marker({
                        position: { lat: position.adresse.lat, lng: position.adresse.lng },
                        icon: '/app/themes/perfeo/dist/images/marker.png',
                    });

                    let contentString;
                    if (type == 'location') {
                        contentString = '<div class="marker-content">' +
                            '<div class="marker-image">' +
                            '<img src="/app/themes/perfeo/dist/images/marker.png">' +
                            '</div>' +
                            '<strong>' + position.nom + '</strong>' +
                            '<div id="bodyContent">' +
                            (typeof position.adresse.street_number != 'undefined' ? position.adresse.street_number : '') + " " +
                            (typeof position.adresse.street_name != 'undefined' ? position.adresse.street_name : '') + "<br>" +
                            (typeof position.adresse.post_code != 'undefined' ? position.adresse.post_code : '') + " " +
                            (typeof position.adresse.city != 'undefined' ? position.adresse.city : '') + "<br>" +
                            (typeof position.adresse.country != 'undefined' ? position.adresse.country : '') + "<br>" +
                            (typeof position.telephone != 'undefined' ? "<i class='fas fa-phone fa-rotate-90'></i> <a class='' href='tel:" + position.telephone.replace(' ', '') + "'>" + position.telephone + "</a>" : '') + "<br>" +
                            (position.email != "" ? "<i class='fas fa-envelope'></i> <a class='implantation-lien-contact' href='mailto:" + position.email + "'>" + translate.contact + "</a>" : "") +
                            '</div>' +
                            '</div>';
                    } else {
                        contentString = '<div class="marker-content">' +
                            '<div class="marker-image">' +
                            '<img src="/app/themes/perfeo/dist/images/marker.png">' +
                            '</div>' +
                            '<strong>' + position.adresse.city + '</strong>' +

                            '<div id="bodyContent">';
                        for (let i = 0; i < position.experts.length; i++) {
                            contentString += '<div>' +
                                '<a href="' + position.experts[i].url + '">' + position.experts[i].nom + ' ' + position.experts[i].prenom + '</a>' +
                                '<p><a href="' + position.experts[i].tag.link + '" class="tag bg-' + position.experts[i].tag.color + '">' + position.experts[i].tag.name + '</a></p>' +
                                '</div>';
                        }
                        contentString += '</div>' +
                            '</div>';
                    }
                    marker.addListener("click", () => {
                        map.setCenter(marker.getPosition());
                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);
                    });
                    return marker;
                } else {
                    return null;
                }

            });
            if (markers !== undefined) {
                markers.filter(function (el) {
                    return el != null;
                });
            }
            // Add a marker clusterer to manage the markers.
            let markerCluster = new MarkerClusterer({ markers, map, imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });
        });
    } else {
        // CPT implantations map
        $(document).ready(function(){

            // enable deselect for specific radio inputs and trigger filtering
            makeMapRadiosDeselectableByName($inputCountryName);
            makeMapRadiosDeselectableByName($inputRegionName);

            // trigger filtering on checkboxes
            $(document).on('click', 'input[name='+$inputMetierName+']', function() {
                triggerMarkerFiltering();
            })
        });
        
        // load map
        $(window).on('load', function() {
            initMap();
        })
    }
}

/**
 * Prepare and load map
 */
function initMap() {
    var loader = new Loader(maps_api_key, {
        version: "weekly",
        libraries: ["places"]
    });
    let map;
    loader.load().then(function (google) {
        map = new google.maps.Map(document.getElementById('map'), {
            center: { lat: (map_configs.start_lat ? parseInt(map_configs.start_lat) : 0), lng: (map_configs.start_lng ? parseInt(map_configs.start_lng) : 0) },
            zoom: (map_configs.start_zoom ? parseInt(map_configs.start_zoom) : 2),
            styles: require('./map.json'),
            disableDefaultUI: true,
            zoomControl: true,
            clickableIcons: false,
            fullscreenControl: true
        });    

            for(var i = 0; i < implantations.length; i++) {
                if(implantations[i].imp_map_link && 
                    implantations[i].imp_map_link.lat != null && 
                    implantations[i].imp_map_link.lng != null) {
                     setMarkers(implantations[i], map);
                 }
        }
        markerCluster = new MarkerClusterer({ markers, map, ignoreHiddenMarkers: true, imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });
        
        map.addListener('click', function() {
            if (infowindow) infowindow.close();
        });
    });

    // bind geolocation to button
    $(document).on('click', '.geoloc', function() {
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };

                    panAndZoomTo(map, pos);
                },
                () => {
                    handleLocationError(true);
                },
            );
        } else {
            // browser does'nt support Geolocation
            handleLocationError(false);
        }
    });

    // bind places search on input
    $(document).on('keypress', '#filter-search', function(e) {
        if (e.which == 13) {
            let search_value = $(this).val();

            const request = {
                query: search_value,
                fields: ["geometry"],
            };

            let service = new google.maps.places.PlacesService(map);
            service.findPlaceFromQuery(request, (results, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                    panAndZoomTo(map, results[0].geometry.location);
                }
            })
        }
    });
}

/**
 * Pan and zoom to new location on map
 * Animation effects may not trigger if values are too high
 * @param {google.maps.Map} map 
 * @param {array} location {lat,lng}
 */
function panAndZoomTo(map, location) {
    map.panTo(location);
    map.setZoom((map_configs.geoloc_zoom ? parseInt(map_configs.geoloc_zoom) : 6));
}

/**
 * Sets marker for map display
 * @param {array} marker 
 * @param {google.maps.Map} map 
 */
function setMarkers(marker, map) {

    if(typeof marker.metiers !== 'undefined' && marker.metiers.length > 0) {
        const svgPath = 'M37.8936 31.9335C37.89 31.9388 37.8937 31.9461 37.9002 31.9461C37.907 31.9461 37.9107 31.954 37.9063 31.9592L37.5322 32.3985C37.0402 33.0698 36.5067 33.7109 35.9318 34.3219L23.0281 49.7989C21.8299 51.236 19.6229 51.2377 18.4225 49.8023L5.16434 33.9483C4.86796 33.5961 4.57158 33.2352 4.2752 32.8655L3.87602 32.3853C3.86976 32.3778 3.87511 32.3664 3.88491 32.3664C3.89437 32.3664 3.89982 32.3556 3.89425 32.3479C1.68482 29.3176 0.359967 25.7492 0.063592 22.0298C-0.233384 18.3028 0.513675 14.5671 2.22342 11.2293C3.93316 7.89149 6.54005 5.07965 9.76021 3.09995C12.9804 1.12025 16.6904 0.048567 20.4862 0.00161213C24.282 -0.0453428 28.0182 0.934225 31.2878 2.83365C34.5574 4.73307 37.2352 7.47954 39.0295 10.774C40.8239 14.0684 41.666 17.7845 41.4642 21.5177C41.2626 25.2457 40.0277 28.8481 37.8936 31.9335ZM21.2078 28.5844C25.2818 28.5844 28.5844 25.2818 28.5844 21.2078C28.5844 17.1338 25.2818 13.8312 21.2078 13.8312C17.1338 13.8312 13.8312 17.1338 13.8312 21.2078C13.8312 25.2818 17.1338 28.5844 21.2078 28.5844Z';
        var svgMarker = null;
        if (marker.metiers.length > 1) {
            svgMarker = '/app/themes/perfeo/dist/images/imp_marker_maison.svg';
        } else {
            svgMarker = {
                path: svgPath,
                fillColor: marker.metiers[0].color,
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 1,
                size: new google.maps.Size(42, 51),
                anchor: new google.maps.Point(0, 51),
            };
        }

        var markerMap = new google.maps.Marker({
            position: { lat: marker.imp_map_link.lat, lng: marker.imp_map_link.lng },
            icon: svgMarker,
            map: map,
            category: marker.category_metier_arr,
            country: marker.imp_pays,
            region: marker.imp_region
        });

        markers.push(markerMap);
        var content = makeInfoWindow(marker);

        infowindow = new google.maps.InfoWindow({
            //pixelOffset: new google.maps.Size(-1, 45),
            maxWidth: 378,
            content: content,
        });
        google.maps.event.addListener(markerMap, 'click', (function(marker1, content) {
            return function () {
                infowindow.close();
                infowindow.setContent(content);
                infowindow.open(map, markerMap);
                map.panTo(this.getPosition());
            }
        })(markerMap, content));
    }
}

/**
 * Resets clusters display with filtered markers on map
 * @param {array} array filtered markers
 */
function clusterManager(array) {
    markerCluster.clearMarkers();
    if(!array.length) {
        $('.alert').addClass('is-visible');
    } else {
        $('.alert').removeClass('is-visible');
        for(var i = 0; i < array.length; i++) {
            markerCluster.addMarker(array[i]);
        }
    }
}

/**
 * Build array of filter parameters and trigger filtering
 * Also triggers clusters reset with new filtered markers
 * @param {string} filterCountry 
 * @param {string} filterRegion 
 * @param {int} filterMetier 
 */
function newFilter(filterCountry = 'all', filterRegion = 'all', filterMetier = 0) {
    // Préparation des valeurs de métier
    var metierValues = [];
    
    // Si filterMetier est un tableau
    if (Array.isArray(filterMetier)) {
        metierValues = filterMetier.map(id => Number(id)).filter(id => !isNaN(id));
    } 
    // Si filterMetier est une valeur unique non-nulle
    else if (filterMetier !== 0 && filterMetier !== "0" && filterMetier !== "all") {
        var numericValue = Number(filterMetier);
        if (!isNaN(numericValue)) {
            metierValues.push(numericValue);
        }
    }
    
    // Construction des critères
    var criteria = [
        { Field: "country", Values: filterCountry === "all" ? ["all"] : [filterCountry], Multiple: false },
        { Field: "region", Values: filterRegion === "all" ? ["all"] : [filterRegion], Multiple: false },
        { Field: "category", Values: metierValues.length > 0 ? metierValues : 0, Multiple: true }
    ];
    
    // console.log("Critères de filtrage finaux:", criteria);
    
    // Application du filtre
    var filtered = markers.flexFilter(criteria);
    
    // Mise à jour de l'affichage
    if (filtered && filtered.length) {
        clusterManager(filtered);
    } else {
        // console.log("Aucun marqueur ne correspond aux critères");
        clusterManager([]); // Afficher une carte vide
    }
    
    return filtered;
}

/**
 * Build infoWindow html string
 * 
 * @param {Array} marker 
 * @returns {string} html string
 */
function makeInfoWindow(marker) {

    let is_maison_stelliant = false;
    if (marker.metiers.length > 1)
        is_maison_stelliant = true;

    let metiers = '';
    for (let i = 0; i < marker.metiers.length; i++) {
        metiers = ((metiers) ? metiers + ', ' : '') + marker.metiers[i].name;
    }

    const itinerary_source_url = 'https://www.google.com/maps/dir/?api=1&';
    let destination_path = 'destination=' + marker.imp_map_link.address;

    let contentString = '<div class="new-marker-content cpt-imp' + ((is_maison_stelliant) ? ' maison-stelliant' : '') + '">' +
        ((is_maison_stelliant) ? '<div class="title-maison-stelliant"><div class="bg-gradient">' + map_texts.maison_stelliant_string + '</div></div>' : '') +
        '<div class="imp-name">' + marker.post_title + '</div>' +
        ((marker.imp_region != undefined) ? '<div class="imp-region">' + marker.imp_region + '</div>' : '') +
        '<div class="imp-metier">' + metiers + '</div>' +
        ((marker.entite.length > 0) ? '<div class="imp-entite">' + marker.entite[0].name + '</div>' : '') +
        '<div class="position-relative">' +
        '<div class="imp-address imp-address-1">' + marker.imp_adresse_1 + '</div>' +
        ((marker.im_adresse_2 != undefined) ? '<div class="imp-address imp-address-2">' + marker.imp_adresse_2 + '</div>' : '') +
        ((marker.im_adresse_3 != undefined) ? '<div class="imp-address imp-address-3">' + marker.imp_adresse_3 + '</div>' : '') +
        '<div class="imp-cp-ville"><span class="imp-cp">' + marker.imp_code_postal + '</span> <span class="imp-ville">' + marker.imp_ville + '</span></div>' +
        ((marker.imp_pays in countries_list) ? '<div class="imp-country">' + countries_list[marker.imp_pays] + '</div>' : '') +
        '<div class="imp-itinerary"><a href="' + itinerary_source_url + encodeURI(destination_path) + '" target="_blank"><span class="circle"><i class="fas fa-directions"></i></span></a></div>' +
        '</div>' +
        '<div class="imp-tel"><a href="tel:' + marker.imp_tel + '">' + marker.imp_tel + '</a></div>' +
        '<div class="imp-mail"><a href="mailto:' + marker.imp_email + '">' + marker.imp_email + '</a></div>' +
        '<div class="imp-link"><a href="' + marker.imp_link + '" target="_blank">' + marker.imp_link + '</a></div>' +
    '</div>';

    return contentString;
}

/**
 * Filter google map markers by array of filter values
 * @param {array} info 
 * @returns {array} map markers filtered
 */
Array.prototype.flexFilter = function(info) {
    // console.log("Début filtrage - nombre de marqueurs:", this.length);
    // console.log("Critères:", JSON.stringify(info));
    
    var matches = [];
    
    // Parcourir tous les éléments
    for (var i = 0; i < this.length; i++) {
        var item = this[i];
        var matchesAllCriteria = true;
        
        // Vérifier chaque critère
        for (var n = 0; n < info.length; n++) {
            var criterion = info[n];
            var field = criterion.Field;
            var values = criterion.Values;
            
            // Si le critère est "all" ou 0 ou un tableau vide, c'est un match automatique
            if (values === "all" || values === 0 || (Array.isArray(values) && values.length === 0)) {
                continue; // Passer au critère suivant
            }
            
            // Pour le champ "country" ou "region", si la valeur est "all", c'est un match automatique
            if ((field === "country" || field === "region") && 
                (Array.isArray(values) && values.length === 1 && values[0] === "all")) {
                continue;
            }
            
            // Traitement pour le champ category (métiers)
            if (field === "category") {
                // S'assurer que values est un tableau
                var filterValues = Array.isArray(values) ? values : [values];
                
                // Si l'item n'a pas de catégorie définie, c'est un non-match
                if (!item.category) {
                    matchesAllCriteria = false;
                    break;
                }
                
                // Normaliser item.category en tableau
                var itemCategories = Array.isArray(item.category) ? item.category : [item.category];
                
                // console.log("Item categories:", itemCategories);
                // console.log("Filtering by category:", filterValues);
                
                // Vérifier l'intersection entre les catégories de l'item et les valeurs de filtre
                var hasMatch = false;
                
                for (var j = 0; j < itemCategories.length; j++) {
                    var itemCat = String(itemCategories[j]);
                    
                    for (var k = 0; k < filterValues.length; k++) {
                        var filterCat = String(filterValues[k]);
                        
                        if (itemCat === filterCat) {
                            hasMatch = true;
                            // console.log("Match found:", itemCat, "==", filterCat);
                            break;
                        }
                    }
                    
                    if (hasMatch) break;
                }
                
                if (!hasMatch) {
                    matchesAllCriteria = false;
                    break;
                }
            }
            // Pour les autres champs
            else {
                // Normaliser les valeurs en tableaux pour faciliter la comparaison
                var filterValues = Array.isArray(values) ? values : [values];
                var itemValues = Array.isArray(item[field]) ? item[field] : [item[field]];
                
                // Vérifier l'intersection
                var hasMatch = false;
                
                for (var j = 0; j < itemValues.length; j++) {
                    for (var k = 0; k < filterValues.length; k++) {
                        if (String(itemValues[j]) === String(filterValues[k])) {
                            hasMatch = true;
                            break;
                        }
                    }
                    if (hasMatch) break;
                }
                
                if (!hasMatch) {
                    matchesAllCriteria = false;
                    break;
                }
            }
        }
        
        // Si l'item correspond à tous les critères, l'ajouter aux résultats
        if (matchesAllCriteria) {
            matches.push(item);
        }
    }
    
    // console.log("Résultat du filtrage:", matches.length, "marqueurs correspondent");
    return matches;
};

/**
 * Error Alert message for geolocation
 * @param {boolean} browerHasGeolocation 
 */
function handleLocationError(browerHasGeolocation) {
    alert(
        browerHasGeolocation
        ? map_texts.error_geoloc_blocked
        : map_texts.error_geoloc_browser
    );
}

/**
 * Make radio inputs deselectable by clicking again
 * Also triggers map filtering
 * @param {string} name attribute a radio inputs 
 */
var makeMapRadiosDeselectableByName = function(name) {
    $(document).on('click', 'input[name=' + name + ']', function() {

        // test previousState to unselect radio or update all previousStates
        if($(this).attr('previousValue') == 'true'){
            $(this).prop('checked', false)
        } else {
            $('input[name=' + name + ']').attr('previousValue', false);
        }
        // update previous value with current checked state
        $(this).attr('previousValue', $(this).is(':checked'));

        // custom enable/disable filter region tab
        if($(this).hasClass('filter-radio-countries')) { 
            if($(this).val() == $RegionISOCode) {
                $($regionTabId).add($regionWrapId).toggleClass('disabled');                
                $($regionWrapId + ' button').prop('disabled', (i, v) => !v);                
            } else {
                $($regionTabId).add($regionWrapId).addClass('disabled');
                $($regionWrapId + ' button').prop('disabled', true);
            }
        }

        // trigger map maker filtering
        triggerMarkerFiltering();
    });
};

/**
 * Triggers the marker filtering with selected map filters
 */
function triggerMarkerFiltering() {

    var $regionTab = $($regionTabId); // region tab for disabled check

    // get filter selected values
    var $inputCountry   = $('input[name='+$inputCountryName+']:checked');
    var $inputRegion    = $('input[name='+$inputRegionName+']:checked');
    var $inputMetier    = $('input[name='+$inputMetierName+']:checked');

    var metiersValues = [];
    $inputMetier.each(function() {
        metiersValues.push(parseInt($(this).val()));
    });

    // send to filtering process
    newFilter(
        (typeof $inputCountry.val() === 'undefined') ? 'all' : $inputCountry.val(),
        ($regionTab.hasClass('disabled') || typeof $inputRegion.val() === 'undefined') ? 'all' : $inputRegion.val(),
        (metiersValues.length) ? metiersValues : 0
    );
}